export const clinical_self_health_style = {
  addBtnSx: {
    textTransform: 'none',
    height: '40px',
  },
};
